import React from 'react'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { BatchingStrategy, BatchingStrategySymbol, ExperimentsSymbol, Experiments } from '@wix/thunderbolt-symbols'
import type { IThunderboltRootComponentRenderer } from '../types'
import { MegaStoreWithSubscriptions, CatharsisMegaStoreSymbol } from '@wix/thunderbolt-catharsis'

export const ComponentCssRootRenderer = withDependencies(
	[CatharsisMegaStoreSymbol, BatchingStrategySymbol, ExperimentsSymbol],
	(
		catharsisMegaStore: MegaStoreWithSubscriptions,
		batchingStrategy: BatchingStrategy,
		experiments: Experiments
	): IThunderboltRootComponentRenderer => ({
		render: (__, key) => {
			const { ComponentsCss, MegaStoreProvider } = require('../components/ComponentsCss') // ComponentsCss creates a React Context on module state, so it has to be evaluated once React is defined.

			return (
				<MegaStoreProvider megaStore={catharsisMegaStore} batchingStrategy={batchingStrategy}>
					<ComponentsCss key={key} experiments={experiments} />
				</MegaStoreProvider>
			)
		},
	})
)
